<template>
  <ion-page>


    <ion-tabs>
      <ion-tab tab="radio">
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-title>Mes contenus</ion-title>
            <!-- <ion-select slot="end" aria-label="Filter" interface="modal" placeholder="Filtrer" @ionChange="filterChanged">
          <ion-select-option v-for="domain of domains" :key="domain.displayText" :value="domain.id">{{
            domain.displayText }}</ion-select-option>
        </ion-select> -->
            <ion-buttons slot="end">
              <ion-button id="open-modal">
                <i slot="start" class="fal fa-filter" style="margin-right: 10px;" />
                Filtrer
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
          <ion-toolbar>
            <ion-searchbar :animated="true" placeholder="Rechercher..."></ion-searchbar>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <ion-grid>
            <ion-row>
              <ion-col size="12" size-sm="4" v-for="(module, mIdx) of modules" :key="module.id">

                <ion-card>
                  <ion-card-header>
                    <ion-card-title>{{ module.displayText }}</ion-card-title>
                    <ion-card-subtitle>{{ module.domainDisplayText }}</ion-card-subtitle>
                  </ion-card-header>
                  <ion-card-content>
                    <ion-list v-if="titles[mIdx] != undefined">
                      <ion-item v-for="title in titles[mIdx]" :key="'title'+title.id" @click="goToDocument(title.id)">
                        <ion-thumbnail slot="start">
                          <img style="padding: 3px;" alt="RTF"
                            :src="iconSrcs[title.type]" />
                        </ion-thumbnail>
                        <ion-label>
                          <h2>{{title.label}}</h2>
                        </ion-label>
                        <ion-label slot="end" v-if="title.notif">
                          <i class="fa fa-bell" style="color: red"></i>
                        </ion-label>
                      </ion-item>
                    </ion-list>
                  </ion-card-content>

                  <ion-toolbar>
                    <ion-buttons slot="start">
                      <ion-button>
                        <i class="fal fa-circle-info" slot="icon-only" />
                      </ion-button>
                    </ion-buttons>
                    <ion-buttons slot="end">
                      <ion-button>
                        <i class="fal fa-heart" slot="icon-only" />
                      </ion-button>
                    </ion-buttons>
                  </ion-toolbar>
                </ion-card>


              </ion-col>


            </ion-row>
          </ion-grid>
        </ion-content>
      </ion-tab>
      <ion-tab tab="home"></ion-tab>
      <ion-tab tab="library"></ion-tab>
      <ion-tab tab="today"></ion-tab>

      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="today">
          <i class="fal fa-calendar fa-2x" style="margin: 5px;" />
          Aujourd'hui
        </ion-tab-button>
        <ion-tab-button tab="home">
          <i class="fal fa-heart fa-2x" style="margin: 5px;" />
          Favoris
        </ion-tab-button>
        <ion-tab-button tab="radio">
          <i class="fal fa-list fa-2x" style="margin: 5px;" />
          Tous
        </ion-tab-button>
        <ion-tab-button tab="library">
          <i class="fal fa-eye fa-2x" style="margin: 5px;" />
          A consulter
          <ion-badge color="danger">7</ion-badge>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
    
  </ion-page>
</template>

<script lang="ts" setup>
import { getApi } from '@/helpers/api';
import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle, IonButton, IonGrid, IonCol, IonRow, IonTab, IonTabBar, IonTabButton, IonTabs,
  IonToolbar, IonCard, IonSearchbar,/*IonSelect, IonSelectOption,*/ IonCardContent, IonCardTitle, IonCardSubtitle, IonCardHeader
} from '@ionic/vue';
import { GetAllDomainResponse, GetAllModuleResponse, TrainingsApi } from 'ppf-api-client';
import { ref } from 'vue';
import { useRouter } from 'vue-router';



const router = useRouter();
const trainingService = getApi(TrainingsApi);
const domains = ref<GetAllDomainResponse[]>([]);
const modules = ref<GetAllModuleResponse[]>([]);
let allModules: GetAllModuleResponse[] = [];
const titles = ref<{id: number, label: string, type: 'doc'|'pdf'|'video', notif: boolean}[][]>([
  [
    {id: 1, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 2, label: 'Checklists de nettoyage', type: 'pdf', notif: false},
  ],
  [
    {id: 3, label: 'Checklists de démarrage', type: 'doc', notif: false},
  ],
  [
    {id: 4, label: 'Mode opératoire', type: 'doc', notif: false},
  ],
  [
    {id: 5, label: 'Fiche de poste', type: 'pdf', notif: true},
    {id: 6, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 7, label: 'Checklists de démarrage et fin de poste', type: 'doc', notif: false},
  ],
  [
    {id: 8, label: 'Conduite défensive', type: 'doc', notif: false},
    {id: 9, label: 'Fiche de poste', type: 'pdf', notif: true},
  ],
  [
    {id: 10, label: 'Règles de sécurité en entrepôt', type: 'video', notif: true},
  ],
  [
    {id: 11, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 12, label: 'Checklists de nettoyage', type: 'pdf', notif: false},
  ],
  [
    {id: 13, label: 'Checklists de démarrage', type: 'doc', notif: false},
  ],
  [
    {id: 14, label: 'Mode opératoire', type: 'doc', notif: false},
  ],
  [
    {id: 15, label: 'Fiche de poste', type: 'pdf', notif: true},
    {id: 16, label: 'Mode opératoire', type: 'doc', notif: false},
    {id: 17, label: 'Checklists de démarrage et fin de poste', type: 'doc', notif: false},
  ],
  [
    {id: 18, label: 'Mode opératoire', type: 'doc', notif: false},
  ],
  [
    {id: 19, label: 'Checklists de démarrage de poste', type: 'pdf', notif: false},
    {id: 20, label: 'Consignes de nettoyage et rangement', type: 'pdf', notif: false},
  ],
  
  
]);
const iconSrcs = ref<any>({
  pdf: 'https://cdn1.iconfinder.com/data/icons/ios-web-user-interface-square-rounded-shadow-vol-7/512/Document_file_export_sending_exit_send-512.png', 
  doc: 'assets/img/3016779.png',
  video: 'https://cdn1.iconfinder.com/data/icons/ios-web-user-interface-square-rounded-vol-6/512/Document_extension_file_list_menu_text-1024.png'})

trainingService.trainingsGetAllDomainModules().then(x => {
  domains.value = x.domains;
  allModules = x.modules.sort(sortByProperty<GetAllModuleResponse>('displayText'));
  modules.value = allModules;
});

function sortByProperty<T>(propertyName: keyof T): ((a: T, b: T) => number) {
  return function (a: T, b: T) {
    const nameA = (typeof a[propertyName] === 'string') ? ((a[propertyName] as string).toUpperCase() || '') : a[propertyName]; // ignore upper and lowercase
    const nameB = (typeof b[propertyName] === 'string') ? ((b[propertyName] as string).toUpperCase() || '') : b[propertyName]; // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}

function goToDocument(docId: number) {
    router.push(`/document/${docId}`);
}
// function filterChanged(event: any) {
//   modules.value = allModules.filter(x => x.domainId == event.detail.value);
// }
</script>




<style scoped>
.tab-selected .fal {
  font-weight: 900;
}
/* ionic by default has a padding-start of 16px on ion-items => remove it to left-align the list in the cards here */
ion-item {
  --padding-start: 0;
}
</style>